import { useState } from "react";
import { useListBuilder } from "../../../../context/ListBuilderContext/ListBuilderContext";
import { Button, Popover } from "../../../BP2Components";

interface ListBuilderSearchInterface {
   col: any;
   activeSearchColumn: string | null;
   setActiveSearchColumn: (value: string) => void;
}

const ListBuilderSearch: React.FC<ListBuilderSearchInterface> = ({
   col,
   activeSearchColumn,
   setActiveSearchColumn,
}) => {
   const { searchData, setSearchData } = useListBuilder();
   const [inputValue, setInputValue] = useState("");

   return (
      <>
         <Popover
            trigger="click"
            placement="bottom"
            content={
               <div
                  style={{
                     display: "flex",
                     flexDirection: "column",
                     gap: "6px",
                  }}
               >
                  <input
                     value={inputValue}
                     onChange={(e) => setInputValue(e.target.value)}
                     placeholder={
                        searchData?.column === col.key && searchData?.userInput 
                           ? searchData?.userInput 
                           : `Search ${col.name}`
                     }
                     style={{ width: "136px" }}
                  />
                  <div
                     style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "end",
                     }}
                  >
                     <Button
                        style={{
                           width: "60px",
                           height: "30px",
                           marginRight: "1rem",
                        }}
                        buttonType="primary"
                        onClick={() => {
                           setSearchData({
                              column: col.key,
                              userInput: inputValue,
                           });
                        }}
                     >
                        wyszukaj
                     </Button>

                     <Button
                        style={{ width: "60px", height: "30px" }}
                        buttonType="primary"
                        onClick={() => {
                           setInputValue("");
                           setSearchData({
                              column: undefined,
                              userInput: undefined,
                           });
                        }}
                     >
                        wyczyść
                     </Button>
                  </div>
               </div>
            }
         >
            <span
               className="material-symbols-outlined lean"
               style={{ cursor: "pointer", color: searchData?.column === col.key ? "#1890ff" : "inherit" }}
               onClick={() => {
                  setActiveSearchColumn(col.key);
                  if (searchData?.column === col.key) {
                     setInputValue(searchData.userInput || "");
                  } else {
                     setInputValue("");
                  }
               }}
            >
               search
            </span>
         </Popover>
      </>
   );
};

export default ListBuilderSearch;
